import { Asset, AssetType } from "../../../api/assets";
import { LegalVerificationDocumentTypes } from "../../../api/legalVerifications";

export const LEGAL_VERIFICATION_DOCUMENT_TYPE_LABELS: Record<LegalVerificationDocumentTypes, string> = {
  [LegalVerificationDocumentTypes.VEHICLE_HYPOTHECATION]: "Vehicle Hypothecation",
  [LegalVerificationDocumentTypes.VEHICLE_DEALER_TAX_INVOICE]: "Vehicle Dealer Tax Invoice",
  [LegalVerificationDocumentTypes.VEHICLE_CERSAI_SEARCH_REPORT]: "Vehicle CERSAI Search Report",
  [LegalVerificationDocumentTypes.PLANT_MACHINERY_DEALER_TAX_INVOICE]: "Plant & Machinery Dealer Tax Invoice",
  [LegalVerificationDocumentTypes.PLANT_MACHINERY_CERSAI_SEARCH_REPORT]: "Plant & Machinery CERSAI Search Report",
  [LegalVerificationDocumentTypes.COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE]: "Commercial Equipment Dealer Tax Invoice",
  [LegalVerificationDocumentTypes.COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT]: "Commercial Equipment CERSAI Search Report",
  [LegalVerificationDocumentTypes.PRECIOUS_METAL_PLEDGE_AGREEMENT]: "Precious Metal Pledge Agreement",
  [LegalVerificationDocumentTypes.PRECIOUS_METAL_OWNERSHIP_DECLARATION]: "Precious Metal Ownership Declaration",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED]: "Residential Registered Sale Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED]: "Residential Primary Title Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_CHAIN_DEED]: "Residential Chain Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED]: "Residential Historical Mother Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE]: "Residential Encumbrance Certificate",
  [LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT]: "Residential CERSAI Search Report",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED]: "Commercial Registered Sale Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED]: "Commercial Primary Title Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_CHAIN_DEED]: "Commercial Chain Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED]: "Commercial Historical Mother Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE]: "Commercial Encumbrance Certificate",
  [LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT]: "Commercial CERSAI Search Report",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED]: "Industrial Registered Sale Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED]: "Industrial Primary Title Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_CHAIN_DEED]: "Industrial Chain Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED]: "Industrial Historical Mother Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE]: "Industrial Encumbrance Certificate",
  [LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT]: "Industrial CERSAI Search Report",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED]: "Agricultural Land Registered Sale Deed",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED]: "Agricultural Land Primary Title Deed",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_CHAIN_DEED]: "Agricultural Land Chain Deed",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED]: "Agricultural Land Historical Mother Deed",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE]: "Agricultural Land Encumbrance Certificate",
  [LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT]: "Agricultural Land CERSAI Search Report",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED]: "Non-Agricultural Land Registered Sale Deed",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED]: "Non-Agricultural Land Primary Title Deed",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED]: "Non-Agricultural Land Chain Deed",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED]: "Non-Agricultural Land Historical Mother Deed",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE]: "Non-Agricultural Land Encumbrance Certificate",
  [LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT]: "Non-Agricultural Land CERSAI Search Report",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED]: "Industrial Allotment Registered Sale Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED]: "Industrial Allotment Primary Title Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED]: "Industrial Allotment Chain Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED]: "Industrial Allotment Historical Mother Deed",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE]: "Industrial Allotment Encumbrance Certificate",
  [LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT]: "Industrial Allotment CERSAI Search Report",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED]: "Residential Plot Registered Sale Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED]: "Residential Plot Primary Title Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED]: "Residential Plot Chain Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED]: "Residential Plot Historical Mother Deed",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE]: "Residential Plot Encumbrance Certificate",
  [LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT]: "Residential Plot CERSAI Search Report",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED]: "Commercial Plot Registered Sale Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED]: "Commercial Plot Primary Title Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED]: "Commercial Plot Chain Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED]: "Commercial Plot Historical Mother Deed",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE]: "Commercial Plot Encumbrance Certificate",
  [LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT]: "Commercial Plot CERSAI Search Report",
  [LegalVerificationDocumentTypes.OTHERS]:"Others"
};

export const ASSET_TYPE_TO_LEGAL_VERIFICATION_MAP: Record<AssetType, LegalVerificationDocumentTypes[]> = {
  [AssetType.VEHICLE]: [
    LegalVerificationDocumentTypes.VEHICLE_HYPOTHECATION,
    LegalVerificationDocumentTypes.VEHICLE_DEALER_TAX_INVOICE,
    LegalVerificationDocumentTypes.VEHICLE_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.PLANT_AND_MACHINERY]: [
    LegalVerificationDocumentTypes.PLANT_MACHINERY_DEALER_TAX_INVOICE,
    LegalVerificationDocumentTypes.PLANT_MACHINERY_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.COMMERCIAL_EQUIPMENT]: [
    LegalVerificationDocumentTypes.COMMERCIAL_EQUIPMENT_DEALER_TAX_INVOICE,
    LegalVerificationDocumentTypes.COMMERCIAL_EQUIPMENT_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.PRECIOUS_METAL]: [
    LegalVerificationDocumentTypes.PRECIOUS_METAL_PLEDGE_AGREEMENT,
    LegalVerificationDocumentTypes.PRECIOUS_METAL_OWNERSHIP_DECLARATION,
  ],
  [AssetType.RESIDENTIAL]: [
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_CHAIN_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.RESIDENTIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.COMMERCIAL]: [
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_CHAIN_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.COMMERCIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.INDUSTRIAL]: [
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_CHAIN_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.INDUSTRIAL_REAL_ESTATE_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.AGRICULTURAL]: [
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_CHAIN_DEED,
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.NON_AGRICULTURAL]: [
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_CHAIN_DEED,
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.NON_AGRICULTURAL_LAND_PARCEL_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.INDUSTRIAL_ALLOTMENT]: [
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CHAIN_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.RESIDENTIAL_PLOT]: [
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CHAIN_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.COMMERCIAL_PLOT]: [
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_REGISTERED_SALE_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_PRIMARY_TITLE_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_CHAIN_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_HISTORICAL_MOTHER_DEED,
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_ENCUMBRANCE_CERTIFICATE,
    LegalVerificationDocumentTypes.COMMERCIAL_PLOT_LAND_PARCEL_CERSAI_SEARCH_REPORT,
  ],
  [AssetType.FIXED_DEPOSIT]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.MARKETABLE_SECURITY]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.GOVERNMENT_DEBT_INSTRUMENT]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.SMALL_SAVINGS_SCHEME]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.INSURANCE_SECURITY_ASSET]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.STOCK_AND_INVENTORY]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.TRADE_RECEIVABLE]: [LegalVerificationDocumentTypes.OTHERS],
  [AssetType.CORPORATE_GUARANTEE]: [LegalVerificationDocumentTypes.OTHERS],
};

export const getSupportedLegalDocumentTypesForAssets = (
  assets: Asset[],
): LegalVerificationDocumentTypes[] => {
  const supportedTypes = new Set<LegalVerificationDocumentTypes>();

  assets.forEach((asset) => {
    const typesForAsset =
      ASSET_TYPE_TO_LEGAL_VERIFICATION_MAP[asset.asset_type] || [];
    typesForAsset.forEach((type) => supportedTypes.add(type));
  });

  return Array.from(supportedTypes);
};
